<script setup>
import {onBeforeMount, ref, watch} from "vue"
/*父传子数据*/
const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '温馨提示'
  },
  maxWidth: {
    type: Number,
    default: 400
  },
  // 是否开启禁止esc关闭对话框
  isPersistent: {
    type: Boolean,
    default: true
  }
})

const isShow = ref(false)
const emit = defineEmits(['close'])
onBeforeMount(() => {
  if (props.open) isShow.value = true
})

// 检测open变化，isPersistent为false时会导致第二次打开失败
// 需要配合emit的close使用
watch(
  () => props.open,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      isShow.value = newVal
    }
  }
)

// 检测isShow变化，isPersistent为false时会导致第二次打开失败
// 需要配合emit的close使用
watch(
  () => isShow.value,
  (newVal, oldVal) => {
    if (newVal === false) {
      emit('close')
    }
  }
)


</script>

<template>
  <v-dialog
      v-model="isShow"
      :max-width="`${maxWidth}px`"
      :close-on-back="false"
      transition="dialog-bottom-transition"
      :persistent="props.isPersistent"
  >
    <v-card
        :max-width="`${maxWidth}px`"
        :min-height="150"
        :title="title"
        style="padding: 20px"
    >
      <slot name="content"></slot>
      <template v-slot:actions>
        <slot name="actions"></slot>
      </template>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>